import { usdcToken } from '@shared/data/token'
import type { Coin } from '@injectivelabs/ts-types'
import type { PortfolioSubaccountBalanceV2 } from '@injectivelabs/sdk-ts'
import type { SubaccountBalance } from '@/types'

export const isUsdcDenom = (denom: string) => denom === usdcToken.denom

export function getUsdcBankBalance(balances: Coin[]) {
  const usdcBankBalance = balances.find((balance) =>
    isUsdcDenom(balance.denom)
  )

  return usdcBankBalance?.amount || '0'
}

export const getUsdcSubaccountBalances = (balances: SubaccountBalance[]) =>
  balances.filter((balance) => isUsdcDenom(balance.denom))

export function getUsdcSubaccountBalancesMap(
  balancesMap: Record<string, SubaccountBalance[]>
) {
  const usdcSubaccountBalancesMap = Object.entries(balancesMap).reduce(
    (usdcBalancesMap, [subaccountId, balances]) => {
      usdcBalancesMap[subaccountId] = getUsdcSubaccountBalances(balances)

      return usdcBalancesMap
    },
    {} as Record<string, SubaccountBalance[]>
  )

  return usdcSubaccountBalancesMap
}

export function getDefaultAccountUsdcBalances(
  subaccountsList: PortfolioSubaccountBalanceV2[],
  authZOrDefaultSubaccountId: string
): SubaccountBalance[] {
  const defaultAccountUsdcBalances = subaccountsList
    .filter(
      (balance) =>
        isUsdcDenom(balance.denom) &&
        balance.subaccountId === authZOrDefaultSubaccountId
    )
    .map((balance) => ({
      denom: balance.denom,
      totalBalance: balance.deposit?.totalBalance || '0',
      availableBalance: balance.deposit?.availableBalance || '0'
    }))

  return defaultAccountUsdcBalances
}
